module.exports = __webpack_public_path__ + "img/工厂.87159062.png";